import { render, staticRenderFns } from "./DichVuChatLuongCaoList.vue?vue&type=template&id=755f0538&"
import script from "./DichVuChatLuongCaoList.vue?vue&type=script&lang=js&"
export * from "./DichVuChatLuongCaoList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports